import rootSaga from '../sagas';
import conf from './configureStore';

export const store = conf(window.__INITIAL_STATE__);
store.runSaga(rootSaga);
